"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisconnectIntegrationMutation = exports.useSaveTrolmasterKeyMutation = exports.useGetIntegrationsQuery = exports.integrationApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.integrationApi = (0, react_1.createApi)({
    reducerPath: "integrationApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["integration"],
    endpoints: function (builder) { return ({
        getIntegrations: builder.query({
            // userId is part of the argument so another account signing in on this browser never reuses the cache.
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/integration"),
            keepUnusedDataFor: 0,
            providesTags: ["integration"],
        }),
        saveTrolmasterKey: builder.mutation({
            query: function (_a) {
                var apiKey = _a.apiKey, clientId = _a.clientId;
                return ({ url: "/v1/integration/trolmaster", method: "PUT", body: { apiKey: apiKey, client_id: clientId } });
            },
            invalidatesTags: ["integration"],
        }),
        disconnectIntegration: builder.mutation({
            query: function (_a) {
                var provider = _a.provider, clientId = _a.clientId;
                return ({ url: (0, api_url_1.appendClientId)("/v1/integration/".concat(provider), clientId), method: "DELETE" });
            },
            invalidatesTags: ["integration"],
        }),
    }); },
});
exports.useGetIntegrationsQuery = exports.integrationApi.useGetIntegrationsQuery, exports.useSaveTrolmasterKeyMutation = exports.integrationApi.useSaveTrolmasterKeyMutation, exports.useDisconnectIntegrationMutation = exports.integrationApi.useDisconnectIntegrationMutation;
